import { EstateType } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { EstateRelatedDto } from "@1games-ru/region-shared/dist/types/estate/estate";
import clsx from "clsx";
import { CircleCheckIcon, StarIcon } from "@/shared/icons";
import getEstateImage from "@/domains/estate/helpers/getEstateImage";

export default function PlayerMenuCharacterEstateCard(estate: EstateRelatedDto) {
  const { address, entity, hasResidence } = estate;

  const estateImage = estate?.id
    ? getEstateImage(
        {
          id: estate?.id,
          type: entity.type,
          complexId: entity.type === EstateType.Apartment ? entity.content.complexId : null,
        },
        "medium",
      )
    : ""; // TODO: вынести в другое место, и не лезть в другой модуль

  return (
    <div
      className={clsx(
        "relative flex flex-col justify-end w-[20.5rem] h-[18.625rem] ",
        "rounded-[0.625rem] overflow-clip bg-dark-800",
      )}
    >
      <img
        src="https://hips.hearstapps.com/hmg-prod/images/west-virginia-gray-cottage-64dd6bb056057.jpg?crop=0.943xw:0.817xh;0.0224xw,0.0932xh&resize=980:*" // TODO: estateImage
        // src={estateImage}
        className="absolute left-0 right-0 top-0"
        style={{
          WebkitMaskImage: "linear-gradient(to bottom, black, transparent)",
        }}
        alt=""
      />
      {hasResidence && (
        <div
          className={clsx(
            "absolute top-4 left-4 h-[2rem] bg-dark-800/60 px-2.5 rounded-[0.5rem] flex items-center",
            "uppercase text-white text-11 leading-3 font-bold backdrop-blur-[1px] gap-1.5",
          )}
        >
          <CircleCheckIcon size={14} />
          ПРОПИСКА
        </div>
      )}
      <div className="z-1 h-full w-full flex flex-col justify-end ">
        <div className="grow bg-gradient-to-b from-transparent to-dark-800 " />
        <div className="p-7.5 pt-0 bg-dark-800">
          <div
            className={clsx(
              "h-[1.5rem] w-fit px-1 flex items-center gap-1 bg-white rounded-[0.375rem]",
              " text-dark-900 text-[0.75rem] font-bold leading-[0.75rem] uppercase",
            )}
          >
            <StarIcon size={14} />
            {estate?.level || ""}
          </div>
          <div className="text-18 font-bold mt-3.5">Дом #{estate?.id || 0}</div>
          <div className="text-15 font-medium text-white/50">
            {address.streetName} {address.index}
          </div>
        </div>
      </div>
    </div>
  );
}
